export default __webpack_public_path__ + "static/harris-ac44690a9d50b9a71a90aa692d633868.jpg";